import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
} from '@mui/material';

interface EditNotRegisteredAnimalsProps {
  title: any;
  open: boolean;
  notRegisteredAnimals: any;
  onClose: any;
  onSave: any;
}

export const EditNotRegisteredAnimalsDialog: React.FC<
  EditNotRegisteredAnimalsProps
> = ({ title, open, notRegisteredAnimals, onClose, onSave }) => {
  const [sheetDate, setSheetDate] = useState<any>();
  const [animalSex, setAnimalSex] = useState<any>();
  const [animalSpecies, setAnimalSpecies] = useState<any>();
  // const [animalTreatmentStatus, setAnimalTreatmentStatus] =
  //   useState<boolean>();
  // const [animalSurgeryStatus, setAnimalSurgeryStatus] = useState<boolean>();
  // const [animalSterilization, setAnimalSterilization] = useState<any>();
  const [animalOwnerStatus, setAnimalOwnerStatus] = useState<boolean>();
  // const [fieldName, setFieldName] = useState<any>();
  const [total, setTotal] = useState<any>();

  useEffect(() => {
    setSheetDate(notRegisteredAnimals?.sheetDate);
    setAnimalSex(notRegisteredAnimals?.animalSex);
    setAnimalSpecies(notRegisteredAnimals?.animalSpecies);
    setAnimalOwnerStatus(notRegisteredAnimals?.animalOwnerStatus);
    setTotal(notRegisteredAnimals?.total);
  }, [notRegisteredAnimals]);

  function onSheetDateChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = (event.target as HTMLInputElement).value;
    setSheetDate(value);
  }

  function onAnimalSexChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = (event.target as HTMLInputElement).value;
    setAnimalSex(value);
  }

  function onAnimalSpeciesChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = (event.target as HTMLInputElement).value;
    setAnimalSpecies(value);
  }

  // function onAnimalTreatmentStatusChange(
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) {
  //   const value = (event.target as HTMLInputElement).value;
  //   const newTreatmentStatus = value === '0' ? false : true;
  //   setAnimalTreatmentStatus(newTreatmentStatus);
  // }

  // function onAnimalSurgeryStatusChange(
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) {
  //   const value = (event.target as HTMLInputElement).value;
  //   const newSurgeryStatus = value === '0' ? false : true;
  //   setAnimalSurgeryStatus(newSurgeryStatus);
  // }

  function onAnimalOwnerStatusChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = (event.target as HTMLInputElement).value;
    const newHasOwnerState = value === '0' ? false : true;
    setAnimalOwnerStatus(newHasOwnerState);
  }

  // function onFieldNameChange(
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) {
  //   const value = (event.target as HTMLInputElement).value;
  //   setFieldName(value);
  // }

  function onTotalChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = (event.target as HTMLInputElement).value;
    setTotal(parseInt(value));
  }

  const input = {
    sheetDate,
    animalSpecies,
    animalSex,
    animalOwnerStatus,
    total,
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        disableEnforceFocus
        fullWidth
        scroll="paper"
        maxWidth="sm"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <form
            noValidate
            id="update-not-registered-animals"
            onSubmit={(e) => onSave(e, input)}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="sheetDate"
                  label="Dată înregistrare"
                  variant="outlined"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  onChange={(e) => onSheetDateChange(e)}
                  value={sheetDate}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="animalSpecies"
                  label="Specie"
                  variant="outlined"
                  select
                  fullWidth
                  required
                  onChange={(e) => onAnimalSpeciesChange(e)}
                  value={animalSpecies}
                >
                  <MenuItem value="dog">Caine</MenuItem>
                  <MenuItem value="cat">Pisica</MenuItem>
                  {/* <MenuItem value="other">Altă specie</MenuItem> */}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="animalSex"
                  label="Sex"
                  variant="outlined"
                  select
                  fullWidth
                  required
                  onChange={(e) => onAnimalSexChange(e)}
                  value={animalSex}
                >
                  <MenuItem value="male">Mascul</MenuItem>
                  <MenuItem value="female">Femela</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={4}>
                <TextField
                  id="animalOwnerStatus"
                  label="Are proprietar?"
                  variant="outlined"
                  select
                  fullWidth
                  required
                  onChange={(e) => onAnimalOwnerStatusChange(e)}
                  value={animalOwnerStatus ? '1' : '0'}
                >
                  <MenuItem value="0">Nu</MenuItem>
                  <MenuItem value="1">Da</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  id="total"
                  label="Total"
                  variant="outlined"
                  fullWidth
                  required
                  onChange={(e) => onTotalChange(e)}
                  value={total}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="submit"
            form="update-not-registered-animals"
          >
            Salvează
          </Button>
          <Button onClick={onClose} color="primary">
            Închide
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
